module.exports = __webpack_public_path__ + "img/warning.08043651.svg";